<template>
  <v-container class="text-center fill-height d-flex flex-column justify-start">
    <!-- Background Image -->
    <v-img
      :src="image"
      class="background-image"
      :style="{ opacity: gameStarted ? 0.7 : 1 }"
      cover
    ></v-img>
    
    <v-container
      v-if="!gameStarted"
      fluid
      class="d-flex align-center justify-center fill-height"
    >
      <v-btn
      class="neon-button"
      height = 2.5em
      @click="startGame">Start Game</v-btn>
    </v-container>


    <!-- Game Content -->
    <v-container class="pa-4 game-content mt-1" v-if="gameStarted || showLeaderboard">
      <v-row justify="center">
        <v-col
          sm="12"
          md="8"
          lg="6"
          xl="6"
        >
          <div v-if="gameStarted && timeLeft > 0">
            <v-row class="status-bar py-2 px-4 mb-4 align-center" dense>
              <v-col cols="4" class="text-left text-white font-weight-bold align-center">
                <div class="status-label">Level: <span class="status-score">{{ level }}</span></div>
              </v-col>
              <v-col cols="4" class="text-center text-white font-weight-bold align-center">
                <div class="status-label">Score: <span class="status-score">{{ score }}</span></div>
              </v-col>
              <v-col cols="4" class="text-right text-white font-weight-bold align-center">
                <div class="status-label">Time: <span class="status-score">{{ timeLeft }}</span></div>
              </v-col>
            </v-row>


            <div class="grid">
              <div
                v-for="(cell, index) in grid" 
                :key="index"
                class="grid-cell"
                :class="{ 'flash-border': index === flashingIndex }"
                :style="{ backgroundColor: cell.color }"
                @click="handleClick(index)"
              ></div>
            </div>
          </div>

          <Leaderboard
            v-if="showLeaderboard"
            :score="score"
            :gameId="gameId"
            :playerName.sync="playerName"
            :scoreSubmitted.sync="scoreSubmitted"
            @restart="startGame"
          />
    
        </v-col>
      </v-row>
    </v-container>


  </v-container>
</template>

<script>
import Leaderboard from './Leaderboard.vue';

export default {
  components: { Leaderboard },
  data() {
    return {
      image: require("@/assets/games/color_spotting_poster.png"), 
      gameStarted: false,
      score: 0,
      level: 1,
      timeLeft: 60,
      intervalId: null,
      grid: [],
      differentIndex: -1,
      playerName: '',
      scoreSubmitted: false,
      gameId: 'color-spotting',

      flashingIndex: -1,

    };
  },
  methods: {
    startGame() {
      this.scoreSubmitted = false;
      this.playerName = '';
      this.gameStarted = true;
      this.score = 0;
      this.level = 1;
      this.timeLeft = 60;
      this.generateGrid();

      this.intervalId = setInterval(() => {
        if (this.timeLeft > 0) {
          this.timeLeft--;
        } else {
          clearInterval(this.intervalId);
        }
      }, 1000);
    },
    generateGrid() {
      const totalCells = 25;
      this.differentIndex = Math.floor(Math.random() * totalCells);

      const baseH = Math.floor(Math.random() * 360);
      const baseS = Math.floor(Math.random() * 71) + 20;
      const baseL = Math.floor(Math.random() * 71) + 20;


      const attrToChange = this.level % 2;

      let colorA = `hsl(${baseH}, ${baseS}%, ${baseL}%)`;
      let colorB;

      if (attrToChange === 0) {
        // even level, change saturation
        colorB = `hsl(${baseH}, ${this.getValidSorL(baseS, this.getDifferenceSValue())}%, ${baseL}%)`;
      } else {
        // odd level, change lightness
        colorB = `hsl(${baseH}, ${baseS}%, ${this.getValidSorL(baseL, this.getDifferenceLValue())}%)`;
      }
      
      this.grid = Array.from({ length: totalCells }, (_, i) => ({
        color: i === this.differentIndex ? colorB : colorA
      }));
    },
    handleClick(index) {
      if (index === this.differentIndex) {
        this.score++;
        this.level++;
        
        this.generateGrid();

      }
      else {
        this.score--;
        this.flashingIndex = index;
        setTimeout(() => {
          this.flashingIndex = -1;
        }, 300); // flash for 1 second
      }
    },
    // situation
    getDifferenceSValue() {
      if (this.level <= 5) return 50;
      // if (this.level <= 45) return 50 - 0.75 * (this.level - 5);
      // return 20;
      if (this.level <= 45) return 50 - (this.level - 5);
      return 10;
    },
    // lightness
    getDifferenceLValue() {
      // if (this.level <= 5) return 50;
      // if (this.level <= 45) return 50 - (this.level - 5);
      if (this.level <= 5) return 40;
      if (this.level <= 45) return 40 -  0.75 * (this.level - 5);
      return 10;
    },
    getValidSorL(base, diff) {
      if (base + diff > 90) {
        return base - diff;
      } else if (base - diff < 10) {
        return base + diff;
      } else {
        return base + (Math.random() < 0.5 ? diff : -diff);
      }
    }
  },
  computed: {
    showLeaderboard() {
      return this.timeLeft === 0;
    }
  }
};
</script>

<style scoped>

.neon-button {
  color: #1e1e2f;
  font-size: 20px;
  font-weight: bold;
  padding: 16px 40px;
  background-color: #cffffa;
  border: 2px solid #00ffe7;
  border-radius: 8px;
  text-shadow: 0 0 8px #00ffe7;
  box-shadow: 0 0 8px #00ffe7, 0 0 24px #00ffe7;
  transition: all 0.3s ease;
}

.neon-button:hover {
  background-color: #8cfff4;
  color: #1e1e2f;
  box-shadow: 0 0 20px #00ffe7, 0 0 40px #00ffe7;
}



.background-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  opacity: 1; /* Optional: adjust background visibility */
}

.game-content {
  position: relative;
  height: 100%;
  z-index: 2;
  background: rgba(0, 0, 0, 0.5); /* semi-transparent dark */
  backdrop-filter: blur(15px); /* background blur */
  -webkit-backdrop-filter: blur(10px);
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 0 20px rgba(0, 255, 255, 0.2); /* neon-ish glow */
}


.status-bar {
  background-color: rgba(0, 0, 0, 0.6);
  border: 1px solid rgba(8, 9, 9, 0.3);
  border-radius: 8px;
  box-shadow: 0 0 8px rgba(0, 255, 255, 0.2);
}

.status-label {
  font-size: 1rem;
  letter-spacing: 1px;
  color: #ffffff
}

.status-value {
  color: #00ffe7;
}

.status-score {
  font-size: 2rem;
  font-weight: 700;
  color: #ffffff;
  text-shadow: 0 0 4px #00ffe7;
}



.grid {
  display: grid;
  grid-template-columns: repeat(5, 60px);
  grid-template-rows: repeat(5, 60px);
  gap: 8px;
  justify-content: center;
  margin: 20px 0;
}
.grid-cell {
  width: 60px;
  height: 60px;
  cursor: pointer;
  border-radius: 4px;
}


.flash-border {
  animation: flashBorder 1s ease;
}

@keyframes flashBorder {
  0% {
    box-shadow: 0 0 5px 3px #ff0077, 0 0 12px #ff0077;
  }
  50% {
    box-shadow: 0 0 0 3px transparent;
  }
  100% {
    box-shadow: 0 0 5px 3px #ff0077, 0 0 12px #ff0077;
  }
}
.grid-cell {
  width: 60px;
  height: 60px;
  cursor: pointer;
  border-radius: 4px;
  border: 4px solid transparent; /* default border */
  transition: border 0.2s ease;
}
</style>
